import { Component, OnDestroy, OnInit } from '@angular/core';
import { MonoTypeOperatorFunction, Subscription } from 'rxjs';
import { delay, take } from 'rxjs/operators';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { environment } from 'src/environments/environment';
import { ProjectFormComponent } from '../project-form/project-form.component';
import { ProjectUploadStatus } from '../state/project.model';
import { ProjectQuery } from '../state/project.query';
import { ProjectService } from '../state/project.service';

@Component({
  selector: 'app-project-upload-status',
  templateUrl: './project-upload-status.component.html',
  styleUrls: ['./project-upload-status.component.scss']
})
export class ProjectUploadStatusComponent implements OnInit, OnDestroy {

  projectUi$ = this.projectQuery.selectUi(this.projectQuery.getActiveId());

  ProjectUploadStatus = ProjectUploadStatus;

  lastSub: Subscription;

  constructor(
    private projectService: ProjectService,
    private projectQuery: ProjectQuery,
    private windowService: WindowService
  ) { }

  ngOnInit(): void {
    this.updateStatus(delay(0));
  }

  ngOnDestroy(): void {
    if (this.lastSub) {
      this.lastSub.unsubscribe();
    }
  }

  private updateStatus(delayFn: MonoTypeOperatorFunction<ProjectUploadStatus>): void {
    const id = this.projectQuery.getActiveId();

    this.lastSub = this.projectService.getUploadStatus(id)
      .pipe(delayFn, take(1))
      .subscribe(status => {
        this.projectService.updateUI(id, { uploadStatus: status });

        if (!STATUS_STOP.includes(status)) {
          this.updateStatus(delay(environment.project.uploadPollingDelay));
        }
      });
  }

  edit() {
    this.windowService.open({
      componentType: ProjectFormComponent,
      title: $localize`DESIGN EDITION`,
      help: 'ADD_PROJECT',
      config: {
        id: 'PROJECT_EDITION',
        data: this.projectQuery.getActive()
      }
    });
  }

}

const STATUS_STOP: ProjectUploadStatus[] = [ProjectUploadStatus.Processed, ProjectUploadStatus.Error];
